"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9821],{

/***/ 1333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OpenJobsHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _business_finland_wif_ui_lib_dist_JobsHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7025);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _constants_durations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4780);
/* harmony import */ var _hooks_useQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(808);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2652);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(490);









function OpenJobsHeader(props) {
    var _heading = props.heading, heading = _heading === void 0 ? "Find a job in Finland" : _heading, _leadText = props.leadText, leadText = _leadText === void 0 ? "Explore open jobs for English-speaking professionals." : _leadText;
    var _layout = props.layout, layout = _layout === void 0 ? "default" : _layout, filtersVisible = props.filtersVisible, onToggleFilters = props.onToggleFilters, onResetFilters = props.onResetFilters, _headerI18n = props.headerI18n, headerI18n = _headerI18n === void 0 ? {} : _headerI18n;
    var dispatch = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsDispatch */ .SN)();
    var totalJobs = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsState */ .SP)().totalJobs;
    var citiesFilter = useCitiesFilter();
    var categoriesFilter = useCategoriesFilter();
    var searchTypeAhead = useSearchTypeAhead();
    var isWithFilters = layout === "with-filters";
    var handleOpen = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(open) {
        dispatch({
            isCurtainVisible: open
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_finland_wif_ui_lib_dist_JobsHeader__WEBPACK_IMPORTED_MODULE_3__/* .JobsHeader */ .a, {
        heading: heading,
        leadText: leadText,
        categories: categoriesFilter,
        cities: citiesFilter,
        search: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, searchTypeAhead), {
            placeholder: isWithFilters ? headerI18n.searchJobs : undefined
        }),
        onDropdownOpenChange: handleOpen,
        layout: layout,
        filtersVisible: filtersVisible,
        onToggleFilters: onToggleFilters,
        onResetFilters: onResetFilters,
        totalJobs: totalJobs,
        i18n: isWithFilters ? {
            category: headerI18n.categoryLabel,
            city: headerI18n.cityLabel,
            searchLabel: headerI18n.searchLabel,
            showFilters: headerI18n.showFilters,
            hideFilters: headerI18n.hideFilters,
            resetFilters: headerI18n.resetFilters,
            showJobs: headerI18n.showJobs,
            filtersTitle: headerI18n.filtersTitle,
            close: headerI18n.close
        } : undefined
    });
}
function useCitiesFilter() {
    var ref = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsState */ .SP)(), selectedCities = ref.selectedCities, cities = ref.cities;
    var dispatch = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsDispatch */ .SN)();
    var handleSelectedCitiesChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(items) {
        var selectedCities = items.map(function(item) {
            return item.value;
        });
        dispatch(_store__WEBPACK_IMPORTED_MODULE_6__/* .ACTIONS.updateStateWithPageReset */ .aO.updateStateWithPageReset({
            selectedCities: selectedCities
        }));
    }, [
        dispatch
    ]);
    var selectedCitiesDropdownItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return cities.filter(function(city) {
            return selectedCities.includes(city.value);
        });
    }, [
        cities,
        selectedCities
    ]);
    return {
        items: cities,
        onSelectedItemsChange: handleSelectedCitiesChange,
        selectedItems: selectedCitiesDropdownItems
    };
}
function useCategoriesFilter() {
    var ref = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsState */ .SP)(), selectedCategories = ref.selectedCategories, categories = ref.categories;
    var dispatch = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsDispatch */ .SN)();
    var handleSelectedCategoriesChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(items) {
        var selectedCategories = items.map(function(item) {
            return item.value;
        });
        dispatch(_store__WEBPACK_IMPORTED_MODULE_6__/* .ACTIONS.updateStateWithPageReset */ .aO.updateStateWithPageReset({
            selectedCategories: selectedCategories
        }));
    }, [
        dispatch
    ]);
    var selectedCategoriesDropdownItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return categories.filter(function(city) {
            return selectedCategories.includes(city.value);
        });
    }, [
        categories,
        selectedCategories
    ]);
    return {
        items: categories,
        onSelectedItemsChange: handleSelectedCategoriesChange,
        selectedItems: selectedCategoriesDropdownItems
    };
}
function useSearchTypeAhead() {
    var ref = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsState */ .SP)(), query = ref.query, searchHistory = ref.searchHistory;
    var dispatch = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useOpenJobsDispatch */ .SN)();
    var searchRecommendations = []; // useSearchRecommendations();
    var ref1 = useSearchAutocompleteSuggestion(), searchAutocompleteSuggestion = ref1.searchAutocompleteSuggestion, onCurrentWordChange = ref1.onCurrentWordChange;
    var handleSearch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(query) {
        return dispatch(function(state) {
            return _store__WEBPACK_IMPORTED_MODULE_6__/* .ACTIONS.search */ .aO.search(query.trim(), state);
        });
    }, [
        dispatch
    ]);
    var handleClearSearch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return dispatch(function(state) {
            return _store__WEBPACK_IMPORTED_MODULE_6__/* .ACTIONS.search */ .aO.search("", state);
        });
    }, [
        dispatch
    ]);
    var handleRecommendationClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(item) {
        var value = typeof item === "string" ? item : item.value;
        dispatch(_store__WEBPACK_IMPORTED_MODULE_6__/* .ACTIONS.updateStateWithPageReset */ .aO.updateStateWithPageReset({
            selectedCategories: [
                value
            ],
            selectedCities: [],
            query: ""
        }));
    }, [
        dispatch
    ]);
    return {
        defaultValue: query,
        onSearch: handleSearch,
        onCurrentWordChange: onCurrentWordChange,
        onClear: handleClearSearch,
        onSearchRecommendationClick: handleRecommendationClick,
        searchAutocompleteSuggestion: searchAutocompleteSuggestion,
        searchHistory: searchHistory,
        searchRecommendations: searchRecommendations
    };
}
/*
function useSearchRecommendations(): ITypeAheadSearchOption[] {
  const { data } = useQuery<Jobs.Status.Result>("/api/jobs/status", {
    cacheDurationInMs: ONE_DAY_IN_MS,
    initialData: { totalJobs: 0, categories: [] },
  });

  return (data.categories || [])
    .map((category) => ({
      label: category.name,
      value: category.id,
    }))
    .slice(0, 5);
}
*/ function useSearchAutocompleteSuggestion() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), currentWord = ref[0], setCurrentWord = ref[1];
    var ref1 = (0,_hooks_useQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("/api/jobs/autocomplete?word=" + currentWord, {
        cacheDurationInMs: _constants_durations__WEBPACK_IMPORTED_MODULE_8__/* .ONE_MIN_IN_MS */ .sW * 10,
        enableBackgroundFetch: true,
        initialData: {
            suggestions: [],
            limit: 0,
            offset: 0,
            total: 0
        }
    }), _data = ref1.data, searchAutocompleteSuggestion = _data.suggestions;
    return {
        searchAutocompleteSuggestion: searchAutocompleteSuggestion,
        onCurrentWordChange: setCurrentWord
    };
}


/***/ }),

/***/ 2652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SN": function() { return /* binding */ useOpenJobsDispatch; },
/* harmony export */   "SP": function() { return /* binding */ useOpenJobsState; },
/* harmony export */   "UU": function() { return /* binding */ OpenJobsStateContext; },
/* harmony export */   "h8": function() { return /* binding */ OpenJobsDispatchContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(490);


var OpenJobsStateContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(_store__WEBPACK_IMPORTED_MODULE_1__/* .openJobsInitialState */ .$V);
var OpenJobsDispatchContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(function(state) {
    return state;
});
function useOpenJobsState() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(OpenJobsStateContext);
}
function useOpenJobsDispatch() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(OpenJobsDispatchContext);
}


/***/ }),

/***/ 490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ openJobsInitialState; },
/* harmony export */   "aO": function() { return /* binding */ ACTIONS; },
/* harmony export */   "x1": function() { return /* binding */ openJobsStateReducer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3444);
/* harmony import */ var _constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48);
/* harmony import */ var _util_jobs_list__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2670);





var openJobsInitialState = {
    isCurtainVisible: false,
    isError: false,
    totalJobs: 0,
    totalPages: 0,
    jobCards: [],
    query: "",
    page: 1,
    categories: [],
    selectedCategories: [],
    configuredCategories: [],
    cities: [],
    selectedCities: [],
    searchHistory: []
};
function openJobsStateReducer(state, payload) {
    var payloadState = typeof payload === "function" ? payload(state) : payload;
    var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, payloadState);
    updateUrlAndLocalStorage(newState);
    return newState;
}
var ACTIONS = {
    initState: function initState(configuredCategories) {
        var ref, ref1;
        if (false) {}
        var searchParams = new URL(window.location.href).searchParams;
        var savedHistory = window.localStorage.getItem(_constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_JOBS_SEARCH_HISTORY */ .M);
        var searchHistory = savedHistory ? JSON.parse(savedHistory) : [];
        var ref2;
        return {
            query: (ref2 = searchParams.get("query")) !== null && ref2 !== void 0 ? ref2 : "",
            page: (0,_util_jobs_list__WEBPACK_IMPORTED_MODULE_2__/* .parseJobsPage */ .hZ)(searchParams.get("page")),
            selectedCategories: ((ref = searchParams.get("category")) === null || ref === void 0 ? void 0 : ref.split(",")) || [],
            selectedCities: ((ref1 = searchParams.get("city")) === null || ref1 === void 0 ? void 0 : ref1.split(",")) || [],
            searchHistory: searchHistory,
            configuredCategories: configuredCategories
        };
    },
    search: function search(query, state) {
        if (!state) {
            return this.updateStateWithPageReset({
                query: query
            });
        }
        var searchHistory = query ? state.searchHistory.includes(query) ? state.searchHistory : [
            query
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(state.searchHistory)) : state.searchHistory;
        return this.updateStateWithPageReset({
            query: query,
            searchHistory: searchHistory
        });
    },
    updateStateWithPageReset: function updateStateWithPageReset() {
        var newState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, newState), {
            page: 1
        });
    },
    resetState: function resetState() {
        return openJobsInitialState;
    }
};
function updateUrlAndLocalStorage(state) {
    if (false) {}
    // Search history in local storage
    window.localStorage.setItem(_constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_JOBS_SEARCH_HISTORY */ .M, JSON.stringify(state.searchHistory));
    // URL with filters
    var url = new URL(window.location.href);
    setOrDeleteSearchParam(url, "query", state.query, !!state.query);
    setOrDeleteSearchParam(url, "page", state.page.toString(), state.page > 1);
    setOrDeleteSearchParam(url, "category", state.selectedCategories.join(","), Array.isArray(state.selectedCategories) && state.selectedCategories.length > 0);
    setOrDeleteSearchParam(url, "city", state.selectedCities.join(","), Array.isArray(state.selectedCities) && state.selectedCities.length > 0);
    window.history.replaceState(window.history.state, "", url);
}
function setOrDeleteSearchParam(url, name, value, condition) {
    if (condition) {
        url.searchParams.set(name, value);
    } else {
        url.searchParams.delete(name);
    }
}


/***/ }),

/***/ 812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOpenJobsSearch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _constants_durations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4780);
/* harmony import */ var _hooks_useQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(808);
/* harmony import */ var _util_jobs_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2670);




function useOpenJobsSearch(state, dispatch, campaignId) {
    var pageSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : _util_jobs_list__WEBPACK_IMPORTED_MODULE_1__/* .JOBS_PAGE_SIZE */ .pm;
    var _query = state.query, query = _query === void 0 ? "" : _query, _page = state.page, page = _page === void 0 ? 1 : _page, _selectedCategories = state.selectedCategories, selectedCategories = _selectedCategories === void 0 ? [] : _selectedCategories, _selectedCities = state.selectedCities, selectedCities = _selectedCities === void 0 ? [] : _selectedCities, _configuredCategories = state.configuredCategories, configuredCategories = _configuredCategories === void 0 ? [] : _configuredCategories;
    var configuredCategoriesMap = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return configuredCategories.reduce(function(acc, category) {
            acc[category] = true;
            return acc;
        }, {});
    }, [
        configuredCategories
    ]);
    var searchQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var searchParams = new URLSearchParams({
            limit: pageSize.toString(),
            page: page.toString()
        });
        if (query) searchParams.set("query", query.toLowerCase());
        // Filter selectedCategories to only include those configured from CMS
        var validSelectedCategories = configuredCategories.length > 0 ? selectedCategories.filter(function(cat) {
            return configuredCategoriesMap[cat];
        }) : selectedCategories;
        if (validSelectedCategories.length > 0) searchParams.set("category", validSelectedCategories.join(","));
        else if (configuredCategories.length > 0) searchParams.set("category", configuredCategories.join(","));
        if (selectedCities.length > 0) searchParams.set("city", selectedCities.join(","));
        if (campaignId) searchParams.set("campaignId", campaignId);
        return searchParams.toString();
    }, [
        query,
        page,
        selectedCategories,
        selectedCities,
        configuredCategories,
        configuredCategoriesMap,
        campaignId,
        pageSize, 
    ]);
    var handleSuccess = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(result) {
        var filteredResultCategories = configuredCategories.length > 0 ? result.categories.filter(function(c) {
            return configuredCategoriesMap[c.id];
        }) : result.categories;
        var _totalJobs, _totalPages, _totalPages1;
        dispatch(function(state) {
            return {
                isError: false,
                totalJobs: (_totalJobs = result.totalJobs) !== null && _totalJobs !== void 0 ? _totalJobs : 0,
                totalPages: (_totalPages = result.totalPages) !== null && _totalPages !== void 0 ? _totalPages : 0,
                page: (0,_util_jobs_list__WEBPACK_IMPORTED_MODULE_1__/* .clampJobsPage */ .iR)(state.page, (_totalPages1 = result.totalPages) !== null && _totalPages1 !== void 0 ? _totalPages1 : 0),
                jobCards: result.jobs.map(mapJobRecordToJobCardProps),
                cities: getUpdatedDropdownItems(state.cities, state.selectedCities, result.cities),
                categories: getUpdatedDropdownItems(state.categories, state.selectedCategories, filteredResultCategories)
            };
        });
    }, [
        dispatch,
        configuredCategories,
        configuredCategoriesMap
    ]);
    var handleError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch({
            isError: true,
            jobCards: [],
            totalJobs: 0,
            totalPages: 0
        });
    }, [
        dispatch
    ]);
    var handleLoading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch({
            jobCards: undefined,
            isError: false
        });
    }, [
        dispatch
    ]);
    (0,_hooks_useQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("/api/jobs/?" + searchQuery, {
        cacheDurationInMs: _constants_durations__WEBPACK_IMPORTED_MODULE_3__/* .ONE_MIN_IN_MS */ .sW * 10,
        debounceDurationInMs: _constants_durations__WEBPACK_IMPORTED_MODULE_3__/* .ONE_SEC_IN_MS */ .mW,
        onSuccess: handleSuccess,
        onError: handleError,
        onLoading: handleLoading
    });
}
function mapJobRecordToJobCardProps(job) {
    return {
        title: job.title,
        employerName: job.employer.name,
        location: job.employer.city,
        link: job.externalUrl,
        image: job.employer.imageUrl,
        expireDate: job.expireDate,
        isDataLoading: false
    };
}
function getUpdatedDropdownItems(previousItems, selectedItemValues, newCategoriesOrCities) {
    var newItems = newCategoriesOrCities.map(mapCategoryCityItemToDropdownItem);
    // If there are no previous items, then return new items.
    if (previousItems.length === 0) return newItems;
    // If there are no selected items, then return new items.
    // else stick with previous items.
    return selectedItemValues.length === 0 ? newItems : previousItems;
}
function mapCategoryCityItemToDropdownItem(item) {
    return {
        label: item.name,
        value: item.id,
        count: item.count
    };
}


/***/ }),

/***/ 9821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ OpenJobsPage; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ../wif-ui-lib/dist/main.js
var main = __webpack_require__(128);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/SectionHeader.js
var SectionHeader = __webpack_require__(933);
// EXTERNAL MODULE: ../wif-ui-lib/dist/JobList.js
var JobList = __webpack_require__(8132);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Pagination.js
var Pagination = __webpack_require__(3403);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ./src/magnolia/templates/OpenJobsPage/OpenJobs/context.ts
var context = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/magnolia/templates/OpenJobsPage/OpenJobs/store.ts
var store = __webpack_require__(490);
// EXTERNAL MODULE: ./src/magnolia/templates/OpenJobsPage/OpenJobs/OpenJobsHeader.tsx
var OpenJobsHeader = __webpack_require__(1333);
// EXTERNAL MODULE: ./src/magnolia/templates/OpenJobsPage/OpenJobs/useOpenJobsSearch.ts
var useOpenJobsSearch = __webpack_require__(812);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/util/jobs-list.ts
var jobs_list = __webpack_require__(2670);
// EXTERNAL MODULE: ./src/util/cms-background-color.ts
var cms_background_color = __webpack_require__(4770);
;// CONCATENATED MODULE: ./src/magnolia/templates/OpenJobsPage/OpenJobs/OpenJobs.tsx
















function OpenJobs(props) {
    var ref = (0,react.useReducer)(store/* openJobsStateReducer */.x1, store/* openJobsInitialState */.$V), state = ref[0], dispatch = ref[1];
    (0,react.useEffect)(function() {
        dispatch(store/* ACTIONS.initState */.aO.initState(props.categories));
    }, [
        dispatch,
        props.categories
    ]);
    var isMobile = (0,ViewportContext/* default */.Z)().isMobile;
    var pageSize = (0,jobs_list/* getJobsPageSize */.XO)(isMobile);
    (0,useOpenJobsSearch/* default */.Z)(state, dispatch, props.campaignId, pageSize);
    var pageBackgroundColor = (0,cms_background_color/* resolveJobsPageBackgroundColor */.Kk)(props.backgroundColor);
    var jobCardsSectionRef = (0,react.useRef)(null);
    var isCurtainVisible = state.isCurtainVisible, totalJobs = state.totalJobs, jobCards = state.jobCards, page = state.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* OpenJobsDispatchContext.Provider */.h8.Provider, {
        value: dispatch,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* OpenJobsStateContext.Provider */.UU.Provider, {
            value: state,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    backgroundColor: (0,cms_background_color/* uiBackgroundColorHex */.I_)(pageBackgroundColor, "#f5f5f5")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenJobsHeader/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: jobCardsSectionRef,
                        style: {
                            position: "relative",
                            zIndex: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Curtain */.pz, {
                                show: isCurtainVisible
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    visibility: jobCards ? "visible" : "hidden"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* SectionHeader */.M, {
                                    children: totalJobs > 0 ? "There are ".concat(totalJobs, " open jobs right now") : "0 jobs available"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobList/* JobList */.ny, {
                                page: page,
                                pageSize: pageSize,
                                showRange: false,
                                bottomPadding: Block_9b78bd10.a.SMALL,
                                jobCards: jobCards,
                                showLogo: props.showJobLogos !== false,
                                backgroundColor: pageBackgroundColor,
                                skeletonLoadingCount: pageSize
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenJobsPagination, {
                                jobCardsSectionRef: jobCardsSectionRef
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function OpenJobsPagination(props) {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,context/* useOpenJobsState */.SP)(), totalPages = ref.totalPages, page = ref.page;
    var dispatch = (0,context/* useOpenJobsDispatch */.SN)();
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    var scrollToJobCardsStart = function() {
        if (props.jobCardsSectionRef.current) {
            var offsetJobCardSection = props.jobCardsSectionRef.current.offsetTop;
            var headerHeight = viewport === app/* Viewport.xs */.l_.xs ? app/* headerHeightXs */.ip : app/* headerHeightSmAndAbove */.z_;
            var offsetTotal = offsetJobCardSection - headerHeight;
            window.scrollTo(0, offsetTotal);
        }
    };
    var onPagination = function(page) {
        dispatch({
            page: page
        });
        scrollToJobCardsStart();
    };
    if (totalPages === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
        count: totalPages,
        onChange: onPagination,
        value: page,
        i18n: {
            btnPrevText: t("pagination.previousPage"),
            btnNextText: t("pagination.nextPage"),
            btnPageText: t("pagination.goToPage")
        }
    });
}

// EXTERNAL MODULE: ./src/util/SmartEditableArea.tsx
var SmartEditableArea = __webpack_require__(1747);
;// CONCATENATED MODULE: ./src/magnolia/templates/OpenJobsPage/OpenJobsPage.tsx







function OpenJobsPage(props) {
    var title = props.title, metaDescription = props.metaDescription, main = props.main, top = props.top, isPreview = props.isPreview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title + app/* META_TITLE_SUFFIX */.A_
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartEditableArea/* SmartEditableArea */.Z, {
                isPreview: isPreview,
                slotNode: top
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenJobs, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartEditableArea/* SmartEditableArea */.Z, {
                isPreview: isPreview,
                slotNode: main
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/templates/OpenJobsPage/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 1747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SmartEditableArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _magnolia_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9647);





var EditableArea = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1341), __webpack_require__.e(7351)]).then(__webpack_require__.bind(__webpack_require__, 7351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7351)
            ];
        }
    }
});
function SmartEditableArea(props) {
    var slotNode = props.slotNode, isPreview = props.isPreview;
    if (isPreview) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditableArea, {
                className: "EditableArea",
                content: slotNode
            })
        });
    }
    var pageNodes = ((slotNode === null || slotNode === void 0 ? void 0 : slotNode["@nodes"]) || []).map(function(name) {
        return slotNode === null || slotNode === void 0 ? void 0 : slotNode[name];
    }).filter(Boolean);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: pageNodes.map(function(node) {
            var NodeComponent = (0,_magnolia_config__WEBPACK_IMPORTED_MODULE_3__/* .getComponentForMagnoliaTemplate */ .rX)(node["mgnl:template"]);
            if (!NodeComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NodeComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, node), node["@id"]);
        })
    });
}


/***/ })

}]);